// ================================================================
// BBFYB Redesign - JavaScript Pack
// This pack imports the same Stimulus controllers as application.js
// so all existing data-controller bindings continue to work
// ================================================================

// Import Bootstrap CSS first (before custom styles so they can override)
import 'bootstrap/dist/css/bootstrap.min.css'

// Select2 CSS must be imported here, not @import'ed from redesign.scss:
// sass passes `.css`-suffixed imports through as plain CSS @import, which
// gets dropped from the compiled bundle
import 'select2/dist/css/select2.min.css'
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css'

// Import redesign styles (these override Bootstrap where needed)
import '../../assets/stylesheets/redesign.scss'

import Rails from '@rails/ujs';
import "@hotwired/turbo-rails";

import 'jquery'
import '@popperjs/core'
import * as bootstrap from 'bootstrap'

// Make jQuery and Bootstrap available globally
window.$ = window.jQuery = require('jquery')
window.bootstrap = bootstrap

import '@hotwired/turbo-rails'
import './bootstrap_custom'
import "../controllers"
import './dashboard_sidebar'
import './common'

const { Tooltip, Popover } = bootstrap

function initBootstrapComponents() {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
  })

  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
  popoverTriggerList.map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl, {
      trigger: 'focus'
    })
  })
}

// Category button toggle
function initCategoryToggle() {
  document.querySelectorAll('.category-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.category-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
}

// View toggle (grid/list)
function initViewToggle() {
  document.querySelectorAll('.view-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.view-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
}

// Sort toggle for product stores
function initSortToggle() {
  document.querySelectorAll('.sort-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.sort-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
}

// Product image gallery thumbnail switching
function initProductGallery() {
  document.querySelectorAll('.product-thumbnail').forEach(thumb => {
    thumb.addEventListener('click', function() {
      const mainImage = document.getElementById('mainImage');
      const newSrc = this.dataset.src;
      if (mainImage && newSrc) {
        mainImage.src = newSrc;
        document.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });
}

// Intersection observer for fade-in animations
function initScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.animation = 'fadeInUp 0.6s ease-out forwards';
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.province-card, .city-card, .how-step, .faq-item, .store-card').forEach(el => {
    if (!el.style.animation) {
      el.style.opacity = '0';
      observer.observe(el);
    }
  });
}

function initRedesignComponents() {
  initCategoryToggle();
  initViewToggle();
  initSortToggle();
  initProductGallery();
  initScrollAnimations();
}

function initApp() {
  if (document.querySelector('.select2')) {
    import('./select2').then(({ default: initSelect2 }) => initSelect2());
  }
  initBootstrapComponents();
  initRedesignComponents();
}

document.addEventListener('DOMContentLoaded', initApp);

document.addEventListener('turbo:load', initApp);

// Destroy select2 widgets before Turbo snapshots the page, otherwise the
// cached HTML contains the generated containers and every restore + re-init
// stacks another dead widget next to the live one.
document.addEventListener('turbo:before-cache', () => {
  if ($.fn.select2) {
    $('select.select2-hidden-accessible').select2('destroy');
  }
});
document.addEventListener('turbo:render', () => {
  initBootstrapComponents();
  initRedesignComponents();
});

Rails.start();

